import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { usePayment } from '../context/PaymentContext';
import { useAuth } from '../context/AuthContext';
import { getApiUrl } from '../utils/config';
import '../styles/EmailVerification.css';

const API_URL = getApiUrl();

const EmailVerification = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const { fetchProfile } = usePayment();
    const { isAuth, checkAuth } = useAuth();
    const [status, setStatus] = useState('verifying'); // verifying, success, error
    const [message, setMessage] = useState('');
    const [wasAutoLoggedIn, setWasAutoLoggedIn] = useState(false);
    const hasVerified = useRef(false); // Защита от двойного вызова

    useEffect(() => {
        const verifyEmail = async () => {
            // Защита от повторного выполнения
            if (hasVerified.current) {
                console.log('⚠️ Верификация уже выполнена, пропускаем повторный вызов');
                return;
            }

            const token = searchParams.get('token');

            if (!token) {
                setStatus('error');
                setMessage('Токен верификации не найден');
                return;
            }

            hasVerified.current = true; // Помечаем, что верификация начата

            try {
                const response = await fetch(`${API_URL}/api/email-verification/verify?token=${token}`, {
                    method: 'GET',
                    credentials: 'include' // Важно для получения cookie
                });

                const data = await response.json();

                if (response.ok) {
                    setStatus('success');
                    setMessage(data.message || 'Email успешно подтвержден!');
                    
                    // Если произошел автологин, обновляем состояние авторизации
                    if (data.autoLogin) {
                        console.log('✅ Автологин выполнен, обновляем состояние');
                        setWasAutoLoggedIn(true);
                        try {
                            await checkAuth(); // Обновляем состояние авторизации
                            await fetchProfile(); // Загружаем профиль
                        } catch (error) {
                            console.error('Ошибка при обновлении авторизации:', error);
                        }
                    } else if (isAuth) {
                        // Если пользователь уже был авторизован, просто обновляем профиль
                        try {
                            await fetchProfile();
                        } catch (error) {
                            console.error('Ошибка при обновлении профиля:', error);
                        }
                    }
                    
                    // Перенаправление на главную через 7 секунд (увеличено с 3)
                    setTimeout(() => {
                        navigate('/');
                    }, 7000);
                } else {
                    setStatus('error');
                    setMessage(data.message || 'Ошибка при подтверждении email');
                }
            } catch (error) {
                console.error('Ошибка верификации:', error);
                setStatus('error');
                setMessage('Произошла ошибка при подтверждении email');
            }
        };

        verifyEmail();
    }, [searchParams, navigate, isAuth, checkAuth, fetchProfile]);

    return (
        <div className="email-verification-container">
            <div className="email-verification-card">
                {status === 'verifying' && (
                    <>
                        <div className="verification-spinner"></div>
                        <h2>Подтверждение email...</h2>
                        <p>Пожалуйста, подождите</p>
                    </>
                )}

                {status === 'success' && (
                    <>
                        <div className="verification-icon success">
                            <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="12" cy="12" r="10" stroke="#22c55e" strokeWidth="2" fill="rgba(34, 197, 94, 0.1)"/>
                                <path d="M8 12L11 15L16 9" stroke="#22c55e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                        </div>
                        <h2 className="success-title">Email подтвержден!</h2>
                        <p className="success-message">{message}</p>
                        {wasAutoLoggedIn && (
                            <p className="success-message" style={{ marginTop: '10px', color: '#22c55e', fontWeight: '500' }}>
                                ✅ Вы автоматически вошли в свой аккаунт
                            </p>
                        )}
                        {!isAuth && !wasAutoLoggedIn && (
                            <p className="success-message" style={{ marginTop: '10px', color: '#94a3b8' }}>
                                Войдите в свой аккаунт, чтобы начать пользоваться всеми возможностями
                            </p>
                        )}
                        <p className="redirect-message">Вы будете перенаправлены на главную страницу через несколько секунд...</p>
                        <button className="btn-home" onClick={() => navigate('/')}>
                            Перейти на главную сейчас
                        </button>
                    </>
                )}

                {status === 'error' && (
                    <>
                        <div className="verification-icon error">
                            <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="12" cy="12" r="10" stroke="#ef4444" strokeWidth="2" fill="rgba(239, 68, 68, 0.1)"/>
                                <path d="M15 9L9 15M9 9L15 15" stroke="#ef4444" strokeWidth="2" strokeLinecap="round"/>
                            </svg>
                        </div>
                        <h2 className="error-title">Ошибка верификации</h2>
                        <p className="error-message">{message}</p>
                        <div className="error-actions">
                            <button className="btn-home" onClick={() => navigate('/')}>
                                На главную
                            </button>
                            <button className="btn-profile" onClick={() => navigate('/profile')}>
                                В профиль
                            </button>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default EmailVerification;

